<template>
  <v-content class="gd-background">
    <router-view></router-view>
    <FooterApps />
  </v-content>
</template>

<script>
import FooterApps from '@/components/FooterApps'

export default {
  name: 'outlet',
  components: {
    FooterApps
  },
  mounted () {
    window.scrollTo({ top: 0, behavior: 'instant' })
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.$store.dispatch('getRegions', {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Outlet.vue